export default __webpack_public_path__ + "static/media/Mystic's Bracers of the Crumbling Tower.25558f57.jpg";